/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Business_Form_Success_MessageInputs */

const en_business_form_success_message = /** @type {(inputs: Business_Form_Success_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We've received your information and will be in touch shortly.`)
};

const es_business_form_success_message = /** @type {(inputs: Business_Form_Success_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hemos recibido tu información y nos pondremos en contacto pronto.`)
};

/**
* | output |
* | --- |
* | "We've received your information and will be in touch shortly." |
*
* @param {Business_Form_Success_MessageInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const business_form_success_message = /** @type {((inputs?: Business_Form_Success_MessageInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Business_Form_Success_MessageInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_business_form_success_message(inputs)
	return en_business_form_success_message(inputs)
});